import React, { useContext } from 'react';
import TileButton from '../components/TileButton.jsx';
import { InteractionContext } from '../../../contexts';

const ChangeEmail = () => {
  const { values, handleChange } = useContext(InteractionContext);

  return (
    <>
      {values.answers.map((answer, i) => (
        <TileButton
          key={`change_email_button_${i}`}
          buttonText={answer}
          buttonIndex={i}
          onChangeButtonText={handleChange}
        />
      ))}
    </>
  );
};

export default ChangeEmail;
